import Products from "../../components/Products/Products";
import Hero from "../../components/Hero/Hero";
import RawMaterials from "../../components/Materials/RawMaterials";
import Formulations from "../../components/Formulations/Formulations";

export default function Home() {
  return (
    <div>
      <Hero />
      <Products limit={6} />
      <RawMaterials limit={6} />
      <Formulations limit={6} />
    </div>
  );
}
